module.exports = __webpack_public_path__ + "img/ku.0596cd3a.png";